import React from 'react';
import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import { ErrorRouteKeys, MainRouteKeys } from '../enums';
import { MainRoutesConfig } from './config';

const mainRoutesDefined: RouteObject = {
  path: MainRoutesConfig[MainRouteKeys.Root].path,
  element: MainRoutesConfig[MainRouteKeys.Root].element,
  children: [
    {
      path: MainRoutesConfig[MainRouteKeys.Personal].path,
      element: MainRoutesConfig[MainRouteKeys.Personal].element,
      children: [
        {
          path: MainRoutesConfig[MainRouteKeys.PersonalInfo].path,
          element: MainRoutesConfig[MainRouteKeys.PersonalInfo].element,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.PersonalFinancialLimits].path,
          element:
            MainRoutesConfig[MainRouteKeys.PersonalFinancialLimits].element,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.PersonalTwoFaSecurity].path,
          element:
            MainRoutesConfig[MainRouteKeys.PersonalTwoFaSecurity].element,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.PersonalChangePassword].path,
          element:
            MainRoutesConfig[MainRouteKeys.PersonalChangePassword].element,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.PersonalBalance].path,
          element: MainRoutesConfig[MainRouteKeys.PersonalBalance].element,
        },
        // {
        //   path: MainRoutesConfig[MainRouteKeys.DepostitFromMoraPay].path,
        //   element: MainRoutesConfig[MainRouteKeys.DepostitFromMoraPay].element,
        // },
        // {
        //   path: MainRoutesConfig[MainRouteKeys.WithdrawToMoraPay].path,
        //   element: MainRoutesConfig[MainRouteKeys.WithdrawToMoraPay].element,
        // },
        {
          path: MainRoutesConfig[MainRouteKeys.PersonalLogout].path,
          element: MainRoutesConfig[MainRouteKeys.PersonalLogout].element,
        },
      ],
    },
    {
      path: MainRoutesConfig[MainRouteKeys.RequestWithdraw].path,
      element: MainRoutesConfig[MainRouteKeys.RequestWithdraw].element,
      children: [
        {
          path: MainRoutesConfig[MainRouteKeys.BankManagement].path, // New route
          element: MainRoutesConfig[MainRouteKeys.BankManagement].element, // New route
        },
        {
          path: MainRoutesConfig[MainRouteKeys.CreateRequestWithdraw].path,
          element:
            MainRoutesConfig[MainRouteKeys.CreateRequestWithdraw].element,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.RequestWithdrawOwn].path,
          element: MainRoutesConfig[MainRouteKeys.RequestWithdrawOwn].element,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.RequestWithdrawOwnDetail].path,
          element:
            MainRoutesConfig[MainRouteKeys.RequestWithdrawOwnDetail].element,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.CheckRequestWithdrawList].path,
          element:
            MainRoutesConfig[MainRouteKeys.CheckRequestWithdrawList].element,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.CheckRequestWithdrawDetail].path,
          element:
            MainRoutesConfig[MainRouteKeys.CheckRequestWithdrawDetail].element,
        },
      ],
    },
    {
      path: MainRoutesConfig[MainRouteKeys.CompanyDepartment].path,
      element: MainRoutesConfig[MainRouteKeys.CompanyDepartment].element,
      children: [
        {
          path: MainRoutesConfig[MainRouteKeys.Company].path,
          element: MainRoutesConfig[MainRouteKeys.Company].element,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.EInvoiceAccount].path,
          element: MainRoutesConfig[MainRouteKeys.EInvoiceAccount].element,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.MerchantCredential].path,
          element: MainRoutesConfig[MainRouteKeys.MerchantCredential].element,
        },
      ],
    },
    {
      path: MainRoutesConfig[MainRouteKeys.Users].path,
      element: MainRoutesConfig[MainRouteKeys.Users].element,
    },
    {
      path: MainRoutesConfig[MainRouteKeys.UpdateUser].path,
      element: MainRoutesConfig[MainRouteKeys.UpdateUser].element,
    },
    {
      path: MainRoutesConfig[MainRouteKeys.Balance].path,
      element: MainRoutesConfig[MainRouteKeys.Balance].element,
      children: [
        {
          index: true,
          element: <Navigate to={MainRouteKeys.BalanceManage} replace />,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.BalanceManage].path,
          element: MainRoutesConfig[MainRouteKeys.BalanceManage].element,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.TopUp].path,
          element: MainRoutesConfig[MainRouteKeys.TopUp].element,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.Transfers].path,
          element: MainRoutesConfig[MainRouteKeys.Transfers].element,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.TransfersToBankBIDV].path,
          element: MainRoutesConfig[MainRouteKeys.TransfersToBankBIDV].element,
        },
      ],
    },
    {
      path: MainRoutesConfig[MainRouteKeys.Transactions].path,
      element: MainRoutesConfig[MainRouteKeys.Transactions].element,
      children: [
        {
          path: MainRoutesConfig[MainRouteKeys.PointTransactions].path,
          element: MainRoutesConfig[MainRouteKeys.PointTransactions].element,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.PointTransactionDetails].path,
          element:
            MainRoutesConfig[MainRouteKeys.PointTransactionDetails].element,
        },
      ],
    },
    {
      path: MainRoutesConfig[MainRouteKeys.AuditLogsAdmin].path,
      element: MainRoutesConfig[MainRouteKeys.AuditLogsAdmin].element,
    },
    {
      path: MainRoutesConfig[MainRouteKeys.BidvVirtualAccount].path,
      element: MainRoutesConfig[MainRouteKeys.BidvVirtualAccount].element,
    },
    {
      path: MainRoutesConfig[MainRouteKeys.BidvVirtualAccountInquiry].path,
      element:
        MainRoutesConfig[MainRouteKeys.BidvVirtualAccountInquiry].element,
    },
    {
      path: MainRoutesConfig[MainRouteKeys.BidvBankTransferReconciliation].path,
      element:
        MainRoutesConfig[MainRouteKeys.BidvBankTransferReconciliation].element,
    },
    {
      path: MainRoutesConfig[MainRouteKeys.BidvBankTransferWhitelist].path,
      element:
        MainRoutesConfig[MainRouteKeys.BidvBankTransferWhitelist].element,
    },
    {
      path: MainRoutesConfig[MainRouteKeys.BidvTransHistory].path,
      element: MainRoutesConfig[MainRouteKeys.BidvTransHistory].element,
    },
    {
      path: MainRoutesConfig[MainRouteKeys.BidvEkycGuide].path,
      element: MainRoutesConfig[MainRouteKeys.BidvEkycGuide].element,
    },
    {
      path: MainRoutesConfig[MainRouteKeys.BidvTransferDestWhitelist].path,
      element:
        MainRoutesConfig[MainRouteKeys.BidvTransferDestWhitelist].element,
    },
    {
      path: MainRoutesConfig[MainRouteKeys.BidvTransferWithEvidence].path,
      element: MainRoutesConfig[MainRouteKeys.BidvTransferWithEvidence].element,
      children: [
        {
          path: MainRoutesConfig[MainRouteKeys.BidvTransferWithEvidenceCreate]
            .path,
          element:
            MainRoutesConfig[MainRouteKeys.BidvTransferWithEvidenceCreate]
              .element,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.BidvTransferWithEvidenceOwn]
            .path,
          element:
            MainRoutesConfig[MainRouteKeys.BidvTransferWithEvidenceOwn].element,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.BidvTransferWithEvidenceAll]
            .path,
          element:
            MainRoutesConfig[MainRouteKeys.BidvTransferWithEvidenceAll].element,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.BidvTransferWithEvidenceDetails]
            .path,
          element:
            MainRoutesConfig[MainRouteKeys.BidvTransferWithEvidenceDetails]
              .element,
        },
      ],
    },
    {
      path: MainRoutesConfig[MainRouteKeys.Settings].path,
      element: MainRoutesConfig[MainRouteKeys.Settings].element,
      children: [
        {
          index: true,
          element: <Navigate to={MainRouteKeys.AppVersionConfig} replace />,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.AppVersionConfig].path,
          element: MainRoutesConfig[MainRouteKeys.AppVersionConfig].element,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.UnlockSmsRateLimit].path,
          element: MainRoutesConfig[MainRouteKeys.UnlockSmsRateLimit].element,
        },
        {
          path: MainRoutesConfig[MainRouteKeys.BalanceOperationControls].path,
          element:
            MainRoutesConfig[MainRouteKeys.BalanceOperationControls].element,
        },
      ],
    },

    {
      path: '*',
      element: <Navigate to={ErrorRouteKeys.NotFound} replace />,
    },
  ],
};

export default mainRoutesDefined;
